import { IPromise, IHttpService } from 'angular';
import { ILogsResponse } from "../../typings/board/ControllerResponse";

export interface ISortOptions {
    page: number; take: number; pageSize: number; skip: number;
}

export const LOGS_SERVICE: string = "logsService";

export class LogsService {
    static $inject = ["$http"];
    constructor(private $http: IHttpService) { }

    logs(sortOptions: ISortOptions): IPromise<ILogsResponse> {
        return this.$http.get<ILogsResponse>(`api/logs/getlogs`, {
            params: {
                page: sortOptions.page,
                take: sortOptions.take,
                pageSize: sortOptions.pageSize,
                skip: sortOptions.skip,
            }
        }).then(response => {
            return response.data;
        });
    }

}



// WEBPACK FOOTER //
// ./app/logs/logs.service.ts